<template>
  <div class="head">
    <el-row>
      <el-col :span="24">
        <el-col :span="16">
          <div class="grid-content bg-purple job">
            <!-- <span>职业管理</span> -->
            <slot name="title"></slot>
          </div>
        </el-col>

        <el-col :span="8" class="personal-zl">
          <el-col :span="9">
            <!-- <router-link class="info" tag="span" to="/personalHome" style="cursor:pointer"> -->
            <!--     &lt;!&ndash; <span class="img"></span> &ndash;&gt; -->
            <!--     <el-avatar class="userImag" :size="40" :src="$store.state.userImg || circleUrl" style="vertical-align:middle;"></el-avatar> -->
            <!--     <span class="user-info">个人资料</span> -->
            <!-- </router-link> -->
          </el-col>
          <el-col :span="9" style="margin-left: 120px">

            <router-link tag="span" class="personal" to="/">
              <i class="el-icon-switch-button icon"></i>
              <span class="log-out">退出登录</span>
            </router-link>
            <!-- <span class="personal log-out" @click="logOut">退出登录</span> -->
          </el-col>

        </el-col>
      </el-col>
    </el-row>

  </div>
</template>
<script>
// import route from '@/router/index';
export default {
  data() {
    return {
      circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
    }
  },
}
</script>
<style lang="less" scoped>
.head {
  height: 60px;
  background-color: #ffffff;
  // background-color:red;
  .job {
    font-size: 18px;
    font-weight: 400;
    color: #333333;
    line-height: 60px;

    > span {
      margin-left: 30%;
    }
  }


  .personal-zl {
    height: 60px;
    // background-color:red;
    line-height: 60px;

    .img {
      width: 40px;
      height: 40px;
      display: inline-block;
      vertical-align: middle;
      background: #4E72C8;
      border-radius: 50%;
      background: url("../../assets/four.jpg") 100% 100% no-repeat;
    }

    .personal {

      font-size: 14px;
      font-weight: 400;
      color: hsl(0, 0%, 20%);
      line-height: 60px;
      cursor: pointer;
    }

    .info {
      .user-info {
        margin-left: 10px;
        font-size: 14px;
      }
    }

    .icon {
      font-size: 27px;
      line-height: 60px;
      cursor: pointer;
      color: #333333;
    }

    .log-out {
      display: inline-block;
      margin-left: 6px;
      font-size: 14px;
      vertical-align: top;
    }

  }

}
</style>
